<template>
  <v-form v-disable-all="userCanEdit" ref="form" v-model="formPrematriculaValid" @submit.prevent="onSubmit($event)">
    <v-card tile outlined>
      <v-container>
        <v-card-text>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPrematricula.orden" :rules="ordenRules" label="Orden*" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-select :items="localizaciones" item-text="nombre" item-value="nombre" label="Localización"
                v-model="localizacion" no-data-text="Selecciona una opción" return-object />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPrematricula.empresa" label="Empresa" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPrematricula.colegio" label="Colegio" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-select :items="formasConocer" item-text="forma" item-value="forma" label="Origen" v-model="formaConocer"
                no-data-text="Selecciona una opción" return-object :loading="loadingFormas"></v-select>
            </v-col>

            <v-col :class="formaConocer.id != 1 ? 'd-none' : ''" cols="6" sm="6" md="6">
              <v-text-field v-model="amigoField" label="Nº Alumno">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPrematricula.estadio" label="Nº Abonado Fundación Estadio">
              </v-text-field>
            </v-col>
          </v-row>

          <small>*Indica campo requerido</small>
        </v-card-text>

        <v-card-actions v-if="userCanEdit || userCanEditLlodio">
          <v-btn type="submit" color="primary" :loading="loading" text :disabled="!formPrematriculaValid">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-form>
</template>

<script>
import { update } from '@/api/prematriculas.api'
import { getAll } from '@/api/formaConocer.api'
import { mapGetters } from 'vuex'
import { checkPersonaReferencia } from '@/api/personas.api'
import _ from 'lodash'

export default {
  name: 'PrematriculaForm',

  props: {
    item: {
      type: Object,
      required: true,
    },

    userCanEdit: {
      type: Boolean,
      required: true
    },

    userCanEditLlodio: {
      type: Boolean,
      required: true
    }
  },

  data: () => {
    return {
      amigo: null,
      amigoAlt: null,
      amigoField: null,
      amigoFieldChanged: false,
      itemPrematricula: null,
      formasConocer: null,
      formaConocer: null,
      formPrematriculaValid: false,
      loading: false,
      localizacion: null,
      ordenRules: [
        v => !!v || 'El campo es obligatorio',
        v => /^\d*[1-9]\d*$/.test(v) || 'El valor introducido no es valido, solo números positivos',
      ],
    }
  },

  computed: {
    ...mapGetters('App', {
      localizaciones: 'GET_LOCALIZACIONES',
    }),
  },

  created() {
    this.itemPrematricula = Object.assign(this.item.prematricula)
    this.localizacion = this.itemPrematricula.localizacion

    this.initFormasConocer()
    this.initFormaConocerYAmigo()
  },

  watch: {
    amigoField: 'checkAmigoField'
  },

  methods: {
    initFormaConocerYAmigo() {
      this.formaConocer = Object.assign({}, this.itemPrematricula.formaConocer)
      this.amigo = Object.assign({}, this.itemPrematricula.amigo)
      this.amigoAlt = this.itemPrematricula.amigoAlt
      this.amigoField = this.initAmigoField()
    },

    checkAmigoField(newValue, oldValue) {
      if (oldValue == null) {
        return
      }

      this.amigoFieldChanged = true
    },

    initAmigoField() {
      if (this.amigo != null && this.amigo.codigo) {
        return this.amigo.codigo
      }

      if (this.amigoAlt != null && this.amigoAlt) {
        return this.amigoAlt
      }

      return null
    },

    initFormasConocer() {
      this.loadingFormas = true

      getAll().then(response => {
        this.formasConocer = response.data
        this.loadingFormas = false
      })
    },

    async checkAmigo() {
      try {
        if (this.amigoField == null || this.amigoField == "") {
          return false
        }

        return await checkPersonaReferencia(this.amigoField)
      } catch (error) {
        return false
      }
    },

    async onSubmit() {
      this.loading = true;

      if (this.formPrematriculaValid) {
        if (this.formaConocer.id == 1 && this.amigoFieldChanged) {
          const checkResponse = await this.checkAmigo()

          if (!checkResponse) {
            this.amigo = null
            this.amigoAlt = this.amigoField
          } else {
            this.amigo = checkResponse.data
            this.amigoAlt = null
          }
        }

        if (this.formaConocer.id != 1) {
          this.amigo = null
          this.amigoAlt = null
          this.amigoField = null
        }

        let params = {
          orden: parseInt(this.itemPrematricula.orden),
          empresa: this.itemPrematricula.empresa,
          colegio: this.itemPrematricula.colegio,
          formaConocer: !_.isEmpty(this.formaConocer) ? this.formaConocer : null,
          amigo: this.amigo == null || Object.entries(this.amigo).length === 0 ? null : this.amigo,
          amigoAlt: this.amigoAlt != null && this.amigoAlt != "" ? this.amigoAlt : null,
          estadio: this.itemPrematricula.estadio,
          localizacion: this.localizacion.id
        }

        this.item.prematricula.localizacion = this.localizacion

        await update(this.item, params).then(response => {
          this.amigoFieldChanged = false
          this.$emit('submitPrematricula', event, response)
        }).catch(error => {
          console.error(error)
        })
      }

      this.loading = false;
    }
  }
}
</script>
